
const setLoadingFlag = (state, flag) => (state.isLoading = flag);

const setAccessTokenViews = (state, accessTokenViews) => {
  state.items = accessTokenViews;
};

export { setAccessTokenViews, setLoadingFlag };
